import {
  Card,
  CardContent,
  CardHeader,
  CardProps,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { PanelProps } from './Panel.types';

export default function Panel({
  children,
  title,
  titleVariant = 'h5',
  titleStyles,
  headerGridStyles,
  contentStyles,
  divider = false,
  size = false,
  containerStyles = {},
  loading = false,
  subHeader,
  ...rest
}: Partial<PanelProps> & Partial<CardProps>) {
  const { isMobile } = useBreakpoint();

  return (
    <Container maxWidth={size} sx={{ ...containerStyles }} disableGutters>
      <Card {...rest}>
        {title && (
          <CardHeader
            sx={{ paddingBottom: 0, ...titleStyles }}
            title={
              <Grid
                container
                spacing={1}
                direction="row"
                py={2}
                px={isMobile ? 0 : 3}
                justifyContent={'space-between'}
                sx={headerGridStyles}
              >
                <Grid item>
                  <Typography variant={titleVariant}>{title}</Typography>
                </Grid>
                <Grid item>
                  <div>
                    {subHeader}
                    {loading && <CircularProgress size={22} />}
                  </div>
                </Grid>
              </Grid>
            }
          />
        )}
        {divider && <Divider />}
        <CardContent sx={{ px: isMobile ? 2 : 5, ...contentStyles }}>{children}</CardContent>
      </Card>
    </Container>
  );
}
